import { roundPrice, getLawnCareProgramServiceIds } from "~/utils/payment";
import type CartPaymentInfo from "../../../cart/CartPaymentInfo";
import type DiscountInfo from "../../DiscountInfo";
import type CartDiscountStrategy from "./CartDiscountStrategy";
import type { DiscountInfoType } from "../../DiscountInfoType";

export default class PrePayCartDiscountStrategy implements CartDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "prePay";
  }

  getDiscountInfo(cartPaymentInfo: CartPaymentInfo, currentSubtotal: number): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "prePay",
      description: "",
      value: 0,
      amount: 0,
    };

    /** Prepay discount applies only if:
     * - Paying now
     * - Cart has a LCP service
     */
    if (
      cartPaymentInfo.payType === "payNow" &&
      cartPaymentInfo.services.some((service) => isServiceLawnCareProgram(service))
    ) {
      const prePayDiscount = cartPaymentInfo.franchiseDiscounts.find((franchiseDiscount) => franchiseDiscount.name === "PrePayDiscount");
      const prePayDiscountValue = prePayDiscount?.value ?? 0;

      discountInfo.description = `Pre-Pay Discount (${roundPrice(prePayDiscountValue * 100, "nearest", 3)}%)`;
      discountInfo.value = prePayDiscountValue;
      discountInfo.amount = roundPrice(currentSubtotal * prePayDiscountValue, "nearest", 2);
    }

    return discountInfo;
  }

  getMonthlyDiscountInfo(cartPaymentInfo: CartPaymentInfo, currentSubtotal: number): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "prePay",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }

  getInitialPaymentDiscountInfo(cartPaymentInfo: CartPaymentInfo, currentSubtotal: number): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "prePay",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }
}